import { MaybeElement, InputGroup, Intent, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { encodePriceAsInteger } from "../../../../helpers/PriceHelper";

export type NumberCellProps = {
  value: number;
  disabled?: boolean;
  rightElement?: JSX.Element;
  onChange: (newValue: number) => void;
};

export function NumberCell({
  value,
  disabled,
  rightElement,
  onChange,
}: NumberCellProps) {
  const [validationError, setValidationError] = useState(false);
  const [valueAsString, setValueAsString] = useState(value.toString());
  useEffect(() => setValueAsString(value.toString()), [value]);

  return (
    <InputGroup
      value={valueAsString}
      disabled={disabled}
      onChange={(e) => setValueAsString(e.target.value)}
      onBlur={() => {
        const parsedValue = parseFloat(valueAsString);
        if (isNaN(parsedValue)) {
          setValidationError(true);
        } else {
          setValidationError(false);
          setValueAsString(parsedValue.toString());
          onChange(parsedValue);
        }
      }}
      rightElement={
        validationError ? (
          <Tag intent={Intent.DANGER}>Invalid Price</Tag>
        ) : (
          rightElement
        )
      }
      intent={validationError ? Intent.DANGER : Intent.NONE}
      fill
    />
  );
}
